import api from '../../../api';

// Email Templates API
export const getEmailTemplates = async () => {
  try {
    const response = await api.get('/email/templates');
    return response.data;
  } catch (error) {
    console.error('Error fetching email templates:', error);
    throw error;
  }
};

export const getEmailTemplate = async (id) => {
  try {
    const response = await api.get(`/email/templates/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching email template:', error);
    throw error;
  }
};

export const getEmailTemplateByTemplateId = async (templateId) => {
  try {
    const response = await api.get(`/email/templates/template-id/${templateId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching email template by template ID:', error);
    throw error;
  }
};

export const saveEmailTemplate = async (templateData) => {
  try {
    console.log('=== DEBUG: API Save Template ===');
    console.log('Original templateData:', templateData);
    
    // Prepare the data properly
    const dataToSend = {
      templateId: templateData.templateId,
      name: templateData.name,
      type: templateData.type,
      subject: templateData.subject,
      content: templateData.content,
      isActive: true
    };

    console.log('Data to send to backend:', dataToSend);
    console.log('Final templateId:', dataToSend.templateId);

    // Check if template already exists in database
    let existingTemplate = null;
    try {
      existingTemplate = await getEmailTemplateByTemplateId(templateData.templateId);
      console.log('Existing template found:', existingTemplate);
    } catch (error) {
      console.log('No existing template found for templateId:', templateData.templateId);
    }

    if (existingTemplate && existingTemplate.id) {
      // Template exists, use PUT to update
      console.log('Updating existing template with ID:', existingTemplate.id);
      const response = await api.put(`/email/templates/${existingTemplate.id}`, dataToSend);
      return response.data;
    } else {
      // Template doesn't exist, use POST to create
      console.log('Creating new template');
      delete dataToSend.id; // Remove id field completely
      const response = await api.post('/email/templates', dataToSend);
      return response.data;
    }
  } catch (error) {
    console.error('Error saving email template:', error);
    if (error.response && error.response.status === 400) {
      throw new Error('Invalid template data');
    } else if (error.response && error.response.status === 404) {
      throw new Error('Template not found');
    } else {
      throw new Error('Failed to save template: ' + error.message);
    }
  }
};

export const deleteEmailTemplate = async (templateId) => {
  try {
    const response = await api.delete(`/email/templates/${templateId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting email template:', error);
    throw error;
  }
};

export const getTemplatesByType = async (type) => {
  try {
    const response = await api.get(`/email/templates/type/${type}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching templates by type:', error);
    throw error;
  }
};

export const searchTemplates = async (query) => {
  try {
    const response = await api.get(`/email/templates/search?query=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error('Error searching templates:', error);
    throw error;
  }
};

export const testTemplate = async (templateId, testData) => {
  try {
    const response = await api.post(`/email/templates/${templateId}/test`, testData);
    return response.data;
  } catch (error) {
    console.error('Error testing template:', error);
    throw error;
  }
}; 